import React from "react"

const ResultDisplay = ({ result }) => (
  <div
    className={`result-display${result ? " winner-glow-box" : ""}`}
    style={{
      backgroundColor: result ? result.color : "transparent",
      visibility: result ? "visible" : "hidden",
      "--glow-color": result ? result.color : "transparent",
    }}
  >
    {result ? result.text : "\u00A0"}
  </div>
)

export default ResultDisplay
